(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/use-build-animations.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/use-build-animations.js');
"use strict";


const {
  useMemo
} = React;
const {
  keepComposerAsync,
  slideComposerAsync
} = svs.components.onboarding.slides.animations.composers;
const {
  createSlideLeftAsync,
  createSlideRightAsync,
  createResetPositions
} = svs.components.onboarding.slides.animations;

const useBuildAnimations = (animations, keepSlides) => useMemo(() => {
  const composer = keepSlides ? keepComposerAsync : slideComposerAsync;
  return [createResetPositions(animations.setCenter, animations.setRight), createSlideLeftAsync(composer, animations.toCenter, animations.toLeft, animations.setRight), createSlideRightAsync(composer, animations.toCenter, animations.toRight, animations.setLeft)];
}, [keepSlides, animations.toCenter, animations.toLeft, animations.toRight, animations.setCenter, animations.setLeft, animations.setRight]);
setGlobal('svs.components.onboarding.slides.useBuildAnimations', useBuildAnimations);

 })(window);